import { ListeTable } from '@mairistem/liste';

const BordereauTicketListeTableHeader = (props) => (
  <>
    <ListeTable.Column {...props} name="numero" style={{ width: 150 }} verticalAlign="middle">
      N° de bordereau
    </ListeTable.Column>
    <ListeTable.Column
      {...props}
      name="nombreReglements"
      style={{ width: 175 }}
      verticalAlign="middle"
    >
      Nombre de tickets
    </ListeTable.Column>
    <ListeTable.Column {...props} name="montantTotal" style={{ width: 140 }} verticalAlign="middle">
      Montant
    </ListeTable.Column>
    <ListeTable.Column {...props} name="dateRemise" style={{ width: 140 }} verticalAlign="middle">
      Date de remise
    </ListeTable.Column>
    <ListeTable.Column {...props} name="regisseur" verticalAlign="middle">
      Régisseur
    </ListeTable.Column>
    <ListeTable.Column {...props} name="titrage" style={{ width: 150 }} verticalAlign="middle">
      Titrage
    </ListeTable.Column>
    <ListeTable.Column {...props} name="document" style={{ width: 100 }} verticalAlign="middle">
      Document
    </ListeTable.Column>
  </>
);

export default BordereauTicketListeTableHeader;
